import React from "react"

function IconUserGuest({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="user-guest"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-user-guest"
      {...props}
    >
      <path
        d="M11.961 2.182c2.738 0 4.958 2.158 4.958 4.82v2.905c0 1.29-.522 2.462-1.37 3.327l2.486.712a2.181 2.181 0 0 1 1.394 1.217h1.935c.91 0 1.658.698 1.738 1.587l.007.16v4.908c0 .91-.697 1.658-1.586 1.739l-.16.007h-6.09c-.91 0-1.658-.697-1.739-1.587l-.007-.159v-.328H6.523a2.182 2.182 0 0 1-2.182-2.18v-3.262c0-.975.647-1.832 1.585-2.099l2.463-.698a4.735 4.735 0 0 1-1.386-3.344V7.002c0-2.662 2.22-4.82 4.957-4.82zm9.403 14.29h-6.091c-.211 0-.387.15-.428.35l-.009.087v4.91c0 .21.15.386.349.427l.088.009h6.09c.212 0 .387-.15.428-.349l.009-.088V16.91c0-.21-.15-.387-.348-.427l-.088-.01zM19.5 20a.545.545 0 0 1 .098 1.082l-.098.009h-2.364a.545.545 0 0 1-.098-1.082l.098-.009H19.5zm-5.297-5.792c-.608.3-1.288.482-2.008.514l-.234.005a5.053 5.053 0 0 1-2.209-.503l-3.467.985a.873.873 0 0 0-.626.724l-.008.115v3.261c0 .445.333.812.763.866l.11.007 7.002-.001.001-3.272c0-.91.697-1.658 1.587-1.738l.159-.007 2.256-.001-3.326-.955zm5.297 3.428a.545.545 0 0 1 .098 1.082l-.098.01h-2.364a.545.545 0 0 1-.098-1.083l.098-.009H19.5zM11.961 3.491c-1.953 0-3.536 1.473-3.643 3.313l-.005.198v2.905c0 1.302.738 2.444 1.83 3.05l.24.122.233.098.213.073.155.045.192.046.233.04.11.015.208.017.205.006.204-.005.3-.025.216-.034.242-.052.224-.065.178-.062.139-.057.154-.07.24-.125.212-.131c.897-.601 1.498-1.58 1.563-2.687l.006-.199V7.002c0-1.93-1.626-3.511-3.649-3.511z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconUserGuest
